import React from "react";
import styles from "./Testimonials.module.css";
import TestimonialCard from "../../../components/TestimonialCard/TestimonialCard";

const testimonials = [
    {
        id: 1,
        rating: 5,
        testimonial: "From personal shopping to event planning, Oya Concierge is my go-to for everything lifestyle.",
        name: "Rajesh Kumar",
        title: "CTO",
        company: "AutomatePro",
    },
    {
        id: 2,
        rating: 5,
        testimonial: "From personal shopping to event planning, Oya Concierge is my go-to for everything lifestyle.",
        name: "Kavya Reddy",
        title: "Director",
        company: "ShopIndia",
    },
    {
        id: 3,
        rating: 5,
        testimonial: "From personal shopping to event planning, Oya Concierge is my go-to for everything lifestyle.",
        name: "Karan Malhotra",
        title: "Marketing Manager",
        company: "GrowthLab",
    },
    {
        id: 4,
        rating: 4,
        testimonial: "From personal shopping to event planning, Oya Concierge is my go-to for everything lifestyle.",
        name: "Arjun Patel",
        title: "Product Manager",
        company: "TechFlow",
    },
    {
        id: 5,
        rating: 5,
        testimonial: "From personal shopping to event planning, Oya Concierge is my go-to for everything lifestyle.",
        name: "Vikram Mehta",
        title: "Sales Director",
        company: "CorporateHub",
    },
    {
        id: 6,
        rating: 5,
        testimonial: "From personal shopping to event planning, Oya Concierge is my go-to for everything lifestyle.",
        name: "Ritika Singh",
        title: "CEO",
        company: "Digital Co.",
    },
];

function Testimonials() {
    return (
        <section className={styles.section}>

            <div className={styles.heading}>
                <h2>Testimonials</h2>
                <p>What Our Clients Say</p>
            </div>

            {/* Row 1 - scrolls left */}
            <div className={styles.rowWrapper}>
                <div className={styles.rowLeft}>
                    {[...testimonials, ...testimonials].map((item, index) => (
                        <TestimonialCard
                            key={index}
                            rating={item.rating}
                            testimonial={item.testimonial}
                            name={item.name}
                            title={item.title}
                            company={item.company}
                        />
                    ))}
                </div>
            </div>

            {/* Row 2 - scrolls right */}
            <div className={styles.rowWrapper}>
                <div className={styles.rowRight}>
                    {[...testimonials, ...testimonials].map((item, index) => (
                        <TestimonialCard
                            key={index}
                            rating={item.rating}
                            testimonial={item.testimonial}
                            name={item.name}
                            title={item.title}
                            company={item.company}
                        />
                    ))}
                </div>
            </div>

        </section>
    );
}

export default Testimonials;